/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePodosoftEnrollmentDto } from '../../models/create-podosoft-enrollment-dto';
import { PartnerEnrollment } from '../../models/partner-enrollment';

export interface PodosoftEnrollmentControllerCreateEnrollment$Params {
      body: CreatePodosoftEnrollmentDto
}

export function podosoftEnrollmentControllerCreateEnrollment(http: HttpClient, rootUrl: string, params: PodosoftEnrollmentControllerCreateEnrollment$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerEnrollment>> {
  const rb = new RequestBuilder(rootUrl, podosoftEnrollmentControllerCreateEnrollment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerEnrollment>;
    })
  );
}

podosoftEnrollmentControllerCreateEnrollment.PATH = '/api/podosoft/enrollment';
